module.exports = __webpack_public_path__ + "img/landing_hero_banner.a764cb65.jpg";